import { Reveal, Label } from "./Reveal";

const PARAS = [
  "At Mended Alchemy, we believe meaningful change starts with self-awareness. The way we understand ourselves shapes the way we experience life, build relationships and show up as parents.",
  "For mothers, we begin with the mother herself. Her identity, emotional wellbeing, relationships, aspirations and personal growth matter. When a mother has the space to understand and transform herself, she is better able to experience motherhood with greater presence and fulfilment.",
  "For parents, we believe in conscious parenting. The more aware a parent becomes of their own thoughts, emotions, patterns and responses, the more intentionally they can understand and respond to their child.",
  "Our work is therefore not about perfection or prescribed ways of living and parenting. It is about awareness, understanding and conscious choice.",
  "Because when we grow within, it changes what we create around us and children benefit from the relationships, environments and examples we consciously create.",
];

export default function Manifesto() {
  return (
    <section
      id="manifesto-section"
      data-testid="manifesto-section"
      className="py-20 lg:py-32 px-4 sm:px-8 lg:px-12 bg-[#F3EEE3] border-y border-[#2F3B2E]/10"
    >
      <div className="max-w-3xl mx-auto">
        <Reveal>
          <Label>Our Core Philosophy</Label>
          <h2 className="mt-4 font-serif-display text-3xl sm:text-4xl lg:text-5xl font-medium tracking-tight leading-tight text-[#3B352D]">
            Transformation begins within.
          </h2>
        </Reveal>

        <div className="mt-10 space-y-6" data-testid="manifesto-body">
          {PARAS.map((p, i) => (
            <Reveal key={i} delay={0.06 * i}>
              <p className="text-base sm:text-lg leading-[1.85] text-[#3B352D]/85">{p}</p>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.35}>
          <p className="mt-12 font-serif-display text-2xl sm:text-3xl lg:text-4xl italic font-medium leading-snug text-[#2F3B2E] border-l-2 border-[#A8916B] pl-6">
            Grow Within. Parent Consciously. Thrive Together.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
